<template>
  <div class="m-12 mt-2 flex flex-col w-auto">
    <div class="w-full flex flex-row justify-between p-4 px-0">
      <breadcrumbs :links="links"></breadcrumbs>
    </div>

    <element-form
      v-on:add-element="addElement"
      :repos="repos"
      :element="element"
    ></element-form>
  </div>
</template>

<script>
// import Component from "../component_location"
import { reportError, stripHash } from "@/utils.js";
import Breadcrumbs from "@/components/Breadcrumbs.vue";
import "vue-select/dist/vue-select.css";
import ElementForm from "@/views/Narratives/ElementForm.vue";

export default {
  components: { Breadcrumbs, ElementForm },

  props: ["username", "narrativeName"],

  data() {
    return {
      element: {
        type: "Narrative trigger",
        title: "",
        author: "",
        text: "",
        url: "",
        duration: 100,
        number: 0,
        rank: 0,
        startPosition: 50,
        endPosition: 50,
        startOpacity: 100,
        endOpacity: 100,
        startScale: 1.0,
        endScale: 1.0,
        textColor: "#3f3f3f",
        titleColor: "#3f3f3f",
        backgroundColor: "#ffffff",
        pinDuration: 100,
        pinElement: false,
        triggerHook: 0.5,
        startWidth: 20,
        endWidth: 20,
        backgroundOpacity: 100,
        animationHook: 0.5
      },

      elementTypes: [
        "Background",
        "Data chart",
        "Image/video",
        "Narrative trigger",
        "Text",
        "Tick",
        "Title",
        "Audio"
      ],
      numberTicks: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
    };
  },

  watch: {},

  methods: {
    addElement() {
      stripHash(this.element);
      this.$samsa
        .createElement(this.narrative.Oid, this.element)
        .then((res) => {
          this.$store.commit("setNarrative", res.data);
          this.$router.push({
            name: "Narrative",
            params: {
              username: this.username,
              narrativeName: this.narrativeName,
            },
          });
        })
        .catch((err) => {
          reportError(err);
        });
    },
  },

  computed: {
    narrative() {
      return this.$store.state.narrative;
    },

    repos() {
      return this.$store.state.repos;
    },

    // element() {
    //   return this.$store.state.element;
    // },

    links() {
      return [
        {
          name: this.$store.getters['users/nickname'] + "'s narratives",
          route: {
            name: "Narratives",
            params: { username: this.username },
          },
        },
        {
          name: this.narrativeName,
          route: {
            name: "Narrative",
            params: {
              username: this.username,
              narrativeName: this.narrativeName,
            },
          },
        },
        {
          name: "add element",
          route: {
            name: "NewElement",
            params: {
              username: this.username,
              narrativeName: this.narrativeName,
            },
          },
        },
      ];
    },
  },

  mounted() {
    // LOAD THE NARRATIVE
    this.$samsa
      .getNarrative(this.username, this.narrativeName)
      .then((res) => {
        this.$store.commit("setNarrative", res.data);
      })
      .catch((err) => {
        reportError(err);
        this.$route.push({
          name: "Narratives",
          params: { username: this.username },
        });
      });

    // NOW GET REPOS
    this.$samsa
      .getRepos(this.username)
      .then((res) => {
        this.$store.commit("setRepos", res.data);
      })
      .catch((err) => {
        reportError(err);
      });
  },
};
</script>

<style></style>
